import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { UserPasswordResetFormComponent } from './user-password-reset-form.component';

@NgModule({
  declarations: [
    UserPasswordResetFormComponent
  ],
  imports: [
    CommonModule,
    ErrorsExpansionPanelModule,
    FormsModule,
    LoaderModule,
    MatButtonModule,
    MatSnackBarModule
  ],
  exports: [
    UserPasswordResetFormComponent
  ]
})
export class UserPasswordResetFormModule { }
